// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recommended-text[data-v-02272efc] {\n  color: #5db459;\n  font-style: italic;\n}\n.maintenance-window-width[data-v-02272efc] {\n  width: 330px !important;\n}\n.tech-position[data-v-02272efc] {\n  position: absolute;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
